import { Button, CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import CustomerDetails from "./CustomerDetails";

import { Person } from "@mui/icons-material";
import { useIsMutating } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { useCreateDoctypeData } from "../../shared/hooks/useDocTypesData";
import SimpleWidgetsHeader from "../SimpleWidgetsHeader/SimpleWidgetsHeader";
import { useStyles } from "./styles";
import { useCreateCustomerWithAddress } from "../../shared/hooks/useCustomer";
import { PosContext } from "../../shared/PosContext";

function CustomerCreationWizard({ onClose, onConfirm }) {
    const { selectedOrder } = useContext(PosContext);
    const classes = useStyles();
    const isMutating = useIsMutating();
    const [disabled, setDisabled] = useState(false);
    const [formData, setFormData] = useState({
        customer_name: "",
        // territory: "",
        mobile_no: "",
        // email_id: "",
        address_line1: "",
        address_line2: "",
    });

    useEffect(() => {
        if (isMutating) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [isMutating]);

    const requiredFields = [
        "customer_name",
        // "territory",
        "mobile_no",
        "address_line1",
    ];

    // const createCustomerMutation = useCreateDoctypeData();

    const createCustomerMutation = useCreateCustomerWithAddress();

    const handleClose = () => {
        if (onClose) onClose();
        handleReset();
    };

    const handleReset = () => {
        setFormData({
            customer_name: "",
            // territory: "",
            mobile_no: "",
            // email_id: "",
            address_line1: "",
            address_line2: "",
        });
    };

    // Define a function to handle form submission
    const handleSubmit = async () => {
        let requiredField = null;
        requiredFields.forEach((field) => {
            if (!requiredField && formData[field] === "") {
                requiredField = field;
                return;
            }
        });
        if (requiredField) {
            enqueueSnackbar(`${requiredField} is required !`);
            return;
        }

        const customerData = { ...formData };

        // Until we get them from the system.
        customerData["customer_group"] = "Individual";
        customerData["customer_type"] = "Individual";
        customerData["doctype"] = "Customer";

        // remove address fields not to create 2 addreses
        delete customerData.address_line1;
        delete customerData.address_line2;

        createCustomerMutation.mutate(
            {
                customer_name: formData.customer_name,
                mobile_no: formData.mobile_no,
                address_line1: formData.address_line1,
                address_line2: formData.address_line2,
                city: "Ramallah",
                order_name: selectedOrder?.name,
            },
            {
                onSuccess: (data) => {
                    onConfirm(formData.customer_name, data.data.message);
                    console.log(data);
                },
                onError: (err) => {
                    console.log(err);
                },
                onSettled: () => {
                    console.log("settled");
                },
            }
        );

        // createCustomerMutation.mutate(
        //     {
        //         doctype: "Customer",
        //         formData: customerData,
        //     },
        //     {
        //         onSuccess: (customerData) => {
        //             const addressDefaults = {
        //                 docstatus: 1,
        //                 doctype: "Address",
        //                 name: "new-address-1",
        //                 address_type: "Billing",
        //                 links: [
        //                     {
        //                         docstatus: 1,
        //                         doctype: "Dynamic+Link",
        //                         name: "new-dynamic-link-1",
        //                         parent: "new-address-1",
        //                         parentfield: "links",
        //                         parenttype: "Address",
        //                         idx: 1,
        //                         link_doctype: "Customer",
        //                         link_name: formData.customer_name,
        //                     },
        //                 ],
        //             };

        //             const payload = { ...addressDefaults };
        //             if (formData.address_line1) {
        //                 payload.address_line1 = formData.address_line1;
        //             }
        //             if (formData.address_line2) {
        //                 payload.address_line2 = formData.address_line2;
        //             }

        //             createCustomerMutation.mutate(
        //                 {
        //                     doctype: "Address",
        //                     formData: payload,
        //                 },
        //                 {
        //                     onSuccess: (addressData) => {
        //                         onConfirm?.(customerData, addressData);
        //                         handleClose();
        //                     },
        //                 }
        //             );
        //         },
        //         onSettled: (data, error, variables, context) => {},
        //     }
        // );
        return true;
    };

    return (
        <div className={classes.ReserveTableWidget}>
            <SimpleWidgetsHeader title="Create Customer" Icon={Person} />
            <div>
                <CustomerDetails
                    formData={formData}
                    setFormData={setFormData}
                />
                <div>&nbsp;</div>
                <div className={classes.Footer}>
                    <div>
                        <Button disabled={disabled} onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button disabled={disabled} onClick={handleReset}>
                            Reset
                        </Button>
                    </div>
                    <Button
                        variant="contained"
                        disabled={disabled}
                        color="primary"
                        onClick={handleSubmit}
                    >
                        Submit
                        {disabled && (
                            <CircularProgress
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    marginLeft: "5px",
                                }}
                            />
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default CustomerCreationWizard;
